<template>
  <v-app>
    <div>
      <base-header />
    </div>
    <v-content
      :class="breakpoint.smAndDown ? 'backgroundMobile mb-5' : 'backgroundDesktop'"
      class="mt-2"
    >
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import get from 'lodash/get'
import BaseHeader from './components/base-header.vue'

export default {
  name: 'App',
  components: {
    BaseHeader,
  },
  computed: {
    breakpoint() {
      return get(this.$vuetify, 'breakpoint', {})
    },
  },
};
</script>
<style lang="css">
@import url("./assets/styles/main.css");
.rounded {
  border-radius: 5rem
}
.rounded.yellow {
  border: thin solid #FFF59D !important
}
.rounded.red {
  border: thin solid #F8BBD0 !important
}
.rounded.blue {
  border: thin solid #B3E5FC !important
}
.rounded.green {
  border: thin solid #F1F8E9 !important
}
</style>
